import * as types from '@/constants/mutationTypes'

const state = {
  positionsList: []
}
const getters = {
  positionsList: state => state.positionsList
}
const actions = {
  setPositionsList ({commit}, data) {
    commit(types.SET_POSITIONS_LIST, {data})
  }
}
const mutations = {
  [types.SET_POSITIONS_LIST] (state, {data}) {
    state.positionsList = data
  }}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/PositionList/modules/postionsStore.js